import React, {Component} from 'react';
import {Button, Col, Form, Glyphicon, Image, Modal, Row} from 'react-bootstrap'
import {LinkContainer} from 'react-router-bootstrap'
import vylet from '../resources/images/vylet.png'
import tebeznam from '../resources/images/tebeznam.png'
import xls from '../resources/images/xls.png'
import {TypeheadField} from "./form/form";

export default class Home extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isFindPartyModalOpen: false,
			partyId: null
		};

		this.handleFindPartyModalDismissClick = this.handleFindPartyModalDismissClick.bind(this);
		this.handleFindPartyModalOpenClick = this.handleFindPartyModalOpenClick.bind(this);
	}

	handleFindPartyModalDismissClick = e => {
		if (e) {
			e.preventDefault()
		}
		this.setState({isFindPartyModalOpen: false});
	};

	handleFindPartyModalOpenClick = e => {
		this.setState({isFindPartyModalOpen: true});
	};

	renderFindPartyModal() {
		const {onSubmitParty} = this.props;
		const {isFindPartyModalOpen, partyId} = this.state;

		if (!isFindPartyModalOpen) {
			return null
		}

		return (
			<Modal onHide={this.handleFindPartyModalDismissClick} show={true} backdrop={"static"}>
				<Form horizontal onSubmit={(e) => {
					if (partyId) {
						onSubmitParty(partyId)
					}
					return false
				}}>
					<Modal.Header>
						<Modal.Title>{"Vyhledání venčitele na vycházku"}</Modal.Title>
					</Modal.Header>

					<Modal.Body>
						<Row>
							<Col sm={12}>
								<TypeheadField
									autoFocus={true}
									label={"Venčitel"}
									sizes={[2, 10]}
									meta={{}}
									input={{
										name: "partyId",
										onBlur: (value) => {
										},
										onChange: (value) => {
											this.setState({partyId: value});
										},
										value: partyId
									}}
									emptyText={"Vyhledejte dle jména"}
									loadOptions={this.props.onFindParties}
									searchPromptText={null}/>
							</Col>
						</Row>
					</Modal.Body>

					<Modal.Footer>
						<Row>
							<Col sm={12}>
								<Button onClick={this.handleFindPartyModalDismissClick}>Storno</Button>
								{this.state.partyId &&
								<Button type="submit" bsStyle="success"><Glyphicon glyph="arrow-right"/> Nová vycházka</Button>}
							</Col>
						</Row>
					</Modal.Footer>
				</Form>
			</Modal>
		)
	}

	render() {
		return (<div>
				<Row className={'fancy-buttons text-center'}>
					<Col sm={4} smOffset={2} lgOffset={0}>
						<LinkContainer to="/vencitele/novy" exact={true}>
							<a title={"Zaregistrovat nového venčitele"}>
								<Image src={vylet} width={"200"}/>
							</a>
						</LinkContainer>
					</Col>
					<Col sm={4}>
						<Button type="button" bsStyle={"link"} onClick={this.handleFindPartyModalOpenClick} title="Najít existujícího venčitele">
							<Image src={tebeznam} width={"200"}/>
						</Button>
					</Col>
					<Col sm={4} className={'hidden-xs hidden-sm'}>
						<a href={'/rest-service/party/export/'} title={"Exportovat"}>
							<Image src={xls} width={"200"}/>
						</a>
					</Col>
				</Row>
				{this.renderFindPartyModal()}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Home.js